import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['userConfig'])
  },
  mounted() {
    this.setSiteTitle(), this.setSiteIcon();
  },
  methods: {
    setSiteTitle() {
      document.title = this.userConfig?.siteTitle || '拘束感 jvshugan';
    },
    setSiteIcon() {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = this.userConfig?.siteIcon || '/logo.png';
      document.head.appendChild(link);
    }
  }
};